import { type OpalApiRequestParams } from '@opallabs/api'
import { makeQueryHelper, type QueryHelperTypes } from '@opallabs/react-query'
import { type ClientCategoryTypesDocument } from './types'

export type QueryKeyParams =
  OpalApiRequestParams<'ReadCategoryTypesV3'>['query']['filter']

export type WorkspaceCategoryTypesQueryHelperTypes = QueryHelperTypes<
  QueryKeyParams,
  ClientCategoryTypesDocument
>

export const workspaceCategoryTypesQueryHelper = makeQueryHelper<
  QueryKeyParams,
  ClientCategoryTypesDocument
>(['workspace-admin', 'category-types'] as const)
